// =============================================================================
// trackerActions.js
//
// Action creators — funções que criam os objectos de action.
//
// Em vez de escrever { type: 'TRACKER/FETCH_SUCCESS', payload: data }
// espalhado pelo código, criamos funções que o fazem.
// Mais fácil de ler, testar e manter.
//
// Estrutura de uma action: { type: string, payload?: any }
// =============================================================================

import TRACKER from './trackerActionTypes';

// ── Carregar lista de entradas ──────────────────────────────────────────────

export const fetchEntriesRequest = () => ({ type: TRACKER.FETCH_REQUEST });
export const fetchEntriesSuccess = (entries) => ({ type: TRACKER.FETCH_SUCCESS, payload: entries });
export const fetchEntriesFailure = (error) => ({ type: TRACKER.FETCH_FAILURE, payload: error });

// ── Carregar uma entrada completa (para o modal) ────────────────────────────

export const fetchOneRequest = () => ({ type: TRACKER.FETCH_ONE_REQUEST });
export const fetchOneSuccess = (entry) => ({ type: TRACKER.FETCH_ONE_SUCCESS, payload: entry });
export const fetchOneFailure = (error) => ({ type: TRACKER.FETCH_ONE_FAILURE, payload: error });

// ── Criar entrada ───────────────────────────────────────────────────────────

export const createRequest = () => ({ type: TRACKER.CREATE_REQUEST });
export const createSuccess = (entry) => ({ type: TRACKER.CREATE_SUCCESS, payload: entry });
export const createFailure = (error) => ({ type: TRACKER.CREATE_FAILURE, payload: error });

// ── Actualizar entrada ──────────────────────────────────────────────────────

export const updateRequest = () => ({ type: TRACKER.UPDATE_REQUEST });
export const updateSuccess = (entry) => ({ type: TRACKER.UPDATE_SUCCESS, payload: entry });
export const updateFailure = (error) => ({ type: TRACKER.UPDATE_FAILURE, payload: error });

// ── Apagar entrada ──────────────────────────────────────────────────────────

export const deleteRequest = () => ({ type: TRACKER.DELETE_REQUEST });
export const deleteSuccess = (id) => ({ type: TRACKER.DELETE_SUCCESS, payload: id });
export const deleteFailure = (error) => ({ type: TRACKER.DELETE_FAILURE, payload: error });

// ── Modal ───────────────────────────────────────────────────────────────────

// null = modo criar, objecto = modo editar
export const openModal  = (entry = null) => ({ type: TRACKER.OPEN_MODAL,  payload: entry });
export const closeModal = ()             => ({ type: TRACKER.CLOSE_MODAL });

// ── Erros ───────────────────────────────────────────────────────────────────

export const clearError = () => ({ type: TRACKER.CLEAR_ERROR });